import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchServices,
  fetchServicesSuccess,
  fetchServicesFailure,
} from "../slices/servicesSlice";

function* fetchServicesSaga() {
  try {
    const response = yield call(
      fetch,
      `${process.env.REACT_APP_API_URL}/v1/services`,
    );
    if (!response.ok) throw new Error(`API error: ${response.status}`);

    const result = yield response.json();
    yield put(fetchServicesSuccess(result.data || []));
  } catch (error) {
    yield put(fetchServicesFailure(error.message));
  }
}

export function* watchServices() {
  yield takeLatest(fetchServices.type, fetchServicesSaga);
}
